const BASE_SERVER= (!process.env.NODE_ENV || process.env.NODE_ENV === 'development')?"https://oletool.hkmu.edu.hk":"";

// const APP_SERVER = BASE_SERVER+"/course2202/phsin211f_soft.nsf";
const APP_SERVER =  BASE_SERVER+ "/ismart/softskill.nsf";
const OLE_SERVER = "https://ole.hkmu.edu.hk";




const syncAPIUsername = "sync_admin";
const syncAPIPwd = "ibookcasecheers";

//https://oletool.hkmu.edu.hk/OLEHome.nsf?logout

let Config={

    syncAPIUsername : syncAPIUsername,
    syncAPIPwd : syncAPIPwd,
    VERIFY_OLE_USER : BASE_SERVER +'/ismart/myole.nsf/UserInfo?OpenPage&rand='+ Math.random(),
    OLECONNECT_LOGIN_URL : 'https://oleconnect.hkmu.edu.hk/ole/api/login',

    OLE_LOGOUT:BASE_SERVER+"/OLEHome.nsf?logout&Random="+Math.random(),
    OLE_LOGIN_URL : APP_SERVER + "/names.nsf?Login",
    VERIFY_EXTERNAL_USER:  APP_SERVER+'/anonymousUserLogin?Open',
    VERIFY_ACTIVATION_CODE:  APP_SERVER+'/anonymousUserVerification?Open',
	GET_ACTIVITY_LIST:  APP_SERVER+'/listClinicalForms?Open',
    GET_STUDENT_LIST: APP_SERVER+'/listStudents?Open',
    SUBMIT_COURSE_ACTIVITY : APP_SERVER+'/submitActivity?Open',
    GET_APPS_RUBRIC :  APP_SERVER+'/listClinicalFormDetails?Open',
    GET_STUDENT_STATUS : APP_SERVER+'/listStudentResult?Open',
    GET_ALL_STUDENT_RESULT : APP_SERVER+'/listAllResults?Open&',
    SUBMIT_RUBRIC_MARKING : APP_SERVER+'/submitTutorAnswer?Open',
    SUBMIT_RUBRIC_MARKING_STUDENT : APP_SERVER+'/submitStudentAnswer?Open',

}


exports.Config=Config;